<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>鸣野退费学生</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="退费时间" label-width="80px">
          <el-date-picker
            v-model="query.daterange"
            @change="selList()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="顾问" label-width="80px" style="margin-left:-15px;" v-if="userIsAdmain">
          <el-select v-model="query.adviserID" filterable clearable @change="selList()">
            <el-option label="请选择" value></el-option>
            <el-option
              v-for="item in adviserList"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="营销" label-width="80px" style="margin-left:-15px;" v-if="userIsAdmain">
          <el-select v-model="query.marketID" filterable clearable @change="selList()">
            <el-option label="请选择" value></el-option>
            <el-option
              v-for="item in marketList"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" label-width="60px">
          <el-select v-model="query.eduBack" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地" label-width="70px">
          <el-select v-model="query.province" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in provinceList" :label="item.areaName" :value="item.areaName" :key="item.areaID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生/家长" label-width="80px">
          <el-select v-model="query.studentType" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赴日时间" label-width="80px">
          <el-select v-model="query.abroadPlan" filterable clearable placeholder="请选择" @change="selList()">
            <el-option label="请选择" value></el-option>
            <el-option v-for="item in planList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="exportClick();">导出</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>鸣野退费学生列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
        >
          <el-table-column prop="refundTime" label="退费时间" :width="150"></el-table-column>
          <el-table-column prop="paymentDate" label="缴费时间" :width="120"></el-table-column>
          <el-table-column prop="realName" label="姓名" :width="100"></el-table-column>
          <el-table-column prop="wechat" label="微信" :width="120"></el-table-column>
          <el-table-column prop="eduBack" label="学历" :width="100"></el-table-column>
          <el-table-column prop="refundAmount" label="退费金额" :width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.refundAmount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refundReason" label="退费原因" :width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="origin" label="来源" :width="120"></el-table-column>
          <el-table-column prop="inputTime" label="添加时间" :width="120"></el-table-column>
          <el-table-column prop="marketName" label="营销" :width="100"></el-table-column>
          <el-table-column prop="myAdviserName" label="顾问" :width="100"></el-table-column>
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-mingye="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="showLimitedOpMingye(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="showstuid=scope.row.studentID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="showstuid=scope.row.studentID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditMingye(scope.row)">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog title="编辑退费信息" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" ref="form" label-width="120px">
        <el-form-item label="退费时间" prop="refundTime" :rules="[{ required: true, message: '请填写日期' }]">
          <el-date-picker
            v-model="form.refundTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="退费金额" prop="refundAmount" :rules="[{ required: true, message: '请输入金额' }]">
          <el-input-number v-model="form.refundAmount" :precision="2" :min="0" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="退费原因">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.refundReason"
            placeholder="请输入退费原因"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" @click="submitForm">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分配弹框（鸣野退费：可分配留学、日语） -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserList"
      :market-list="marketList"
      :user-is-admain="userIsAdmain"
      :show-student="true"
      :show-jap="true"
      :show-mingye="false"
      name-label="学生姓名"
      empty-message="请选择分配给留学或日语"
      @success="getList"
    />
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <StudentShow :stuid="showstuid" v-on:setzero="showstuid=0"></StudentShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import StudentShow from "@/components/StudentShow";
import AssignResourceDialog from "@/components/AssignResourceDialog";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import OtherDeptFollow from "@/components/OtherDeptFollow";
export default {
  data() {
    return {
      userIsAdmain: user.isAdmin(),
      userIsAdviser: user.isAdviser(),
      userIsMarket: user.isMarket(),
      query: {},
      form: {},
      submiting: false,
      loading: false,
      dialogVisible: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      adviserList: [],
      marketList: [],
      edubacklist: url.getEduBack(),
      studentTypeList: url.getStudentTypeList(),
      planList: url.getAbroadYear(), // 赴日时间（与留学计划赴日一致）
      provinceList: [],
      showstuid: 0,
      assignDialogVisible: false, //分配对话框显示
      assignForm: {
        resourceTypes: [] // 分配的资源类型：['日语']
      }, //分配表单
      assignSubmiting: false, //分配提交中
      followDialogVisible: false,
      followType: '',
      followDialogRow: null,
    };
  },
  components: {
    StudentShow,
    AssignResourceDialog,
    FollowDetailDialog,
    OtherDeptFollow,
  },
  methods: {
    canEditMingye(row) {
      return user.canEditMingye(row);
    },
    isMarketingOnlyMingye(row) {
      return user.isMarketingOnlyMingye(row);
    },
    isNoAdviserMingye(row) {
      return user.isNoAdviserMingye(row);
    },
    showLimitedOpMingye(row) {
      return user.showLimitedOpMingye(row);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      } else {
        params.start = "";
        params.end = "";
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getMingye("getlist_refund");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    editClick: function (row) {
      // 与留学 Common 一致：不组装对象，直接用列表行整表回填
      this.form = Object.assign({}, row);
      this.form.id = row.studentID;
      var rt = row.refundTime || "";
      if (rt && rt.indexOf(" ") >= 0) rt = rt.replace(" ", "T").substring(0, 19);
      this.form.refundTime = rt;
      this.form.refundAmount = row.refundAmount != null ? row.refundAmount : 0;
      this.form.refundReason = row.refundReason || "";
      this.dialogVisible = true;
    },
    submitForm: function () {
      var _this = this;
      // 与留学 Common 一致：整表传递，只补主表字段
      var info = Object.assign({}, _this.form);
      info.state = "f";
      info.quitTime = _this.form.refundTime ? _this.form.refundTime.replace("T", " ").substring(0, 19) : null;
      info.exitAmount = _this.form.refundAmount != null ? _this.form.refundAmount : 0;
      info.reason = _this.form.refundReason || "";
      this.submiting = true;
      $.post(url.getStu("addorupdate_base"), info, (res) => {
        _this.submiting = false;
        if (res.status) {
          _this.dialogVisible = false;
          _this.getList();
          _this.$message({
            type: "success",
            message: res.msg,
          });
        } else {
          _this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    exportClick: function () {
      var _this = this;
      var params = Object.assign({}, _this.query);
      if (_this.query.daterange && _this.query.daterange.length >= 2) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      }
      params.state = "f"; // 退费学生固定 state=f
      var result = [];
      for (var item in params) {
        if (params[item] && item !== "daterange") {
          var val = Array.isArray(params[item]) ? params[item].join(",") : params[item];
          result.push(item + "=" + encodeURIComponent(val));
        }
      }
      result.push("exportName=鸣野退费学生列表");
      var link = url.getMingye("exportmingye") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    showFollowDialog(type, row) {
      this.followType = type;
      this.followDialogRow = row && (row.studentID != null || row.id != null) ? { ...row, id: row.studentID || row.id } : (row || {});
      this.followDialogVisible = true;
    },
    // 分配
    assignClick: function(row) {
      if (!row) return;
      var _this = this;
      _this.assignForm = {
        studentID: row.studentID || row.id,
        realName: row.realName,
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: true,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: row.marketID || null,
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: row.jpMarketID || null
      };
      _this.assignDialogVisible = true;
    },
  },
  mounted() {
    var _this = this;
    _this.query = _this.$route.query;
    // 顾问/营销老师：不再按板块获取，直接获取所有启用用户
    $.get(url.getStu("getenableusers"), (res) => {
      var list = res || [];
      _this.adviserList = list;
      _this.marketList = list;
    });
    //加载省份列表
    $.get(url.getCommon("getareabyname"), {}, (res) => {
      _this.provinceList = res || [];
    });
    this.getList();
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>


